/**
 * Utilities:
 * - sets page title
 * - sends user id to matomo analytics
 * - sends page change event to matomo analytics.
 * @type {{trackPageChange(*): void, setPageTitle(*): void, tackUserId(*): void}}
 */
let Utils = {
    setPageTitle(route) {
        document.title = route.meta.title + " | MyAmpleon" || "MyAmpleon";
    },
    tackUserId(userId) {
        if(typeof _paq !== 'undefined') {
            _paq.push(['setUserId', userId]);
            _paq.push(['trackPageView']);
        } else {
            console.warn("Can't track userId. Matomo analytics is not included in the website.");
        }
    },
    trackPageChange(route) {
        if(typeof _paq !== 'undefined') {
            _paq.push(['setCustomUrl', window.location.origin + window.location.pathname + route.fullPath]);
            _paq.push(['setDocumentTitle', document.title]);
            _paq.push(['trackPageView']);
        } else {
            console.warn("Can't track MyAmpleon pages. Matomo analytics is not included in the website.");
        }
    },
    enableLinkTracking() {
        if(typeof _paq !== 'undefined') {
            _paq.push(['enableLinkTracking']);
        }
    }
};

export default Utils;
